'use client';

import { useHomeLogicClient } from '../hooks/useHomeLogicClient';

export const HomeLogicWrapper = () => {
  useHomeLogicClient();

  return null;
};
